import {
  InMemoryWebStorage,
  UserManager,
  WebStorageStateStore,
} from 'oidc-client-ts';

const issuer = import.meta.env.VITE_ZITADEL_ISSUER as string;
const clientId = import.meta.env.VITE_ZITADEL_CLIENT_ID as string;
const platformOrgId = import.meta.env.VITE_ZITADEL_PLATFORM_ORG_ID as string;
const redirectUri = import.meta.env.VITE_ZITADEL_REDIRECT_URI as string;
const postLogoutUri = import.meta.env.VITE_ZITADEL_POST_LOGOUT_URI as string;

if (!issuer || !clientId || !redirectUri) {
  // eslint-disable-next-line no-console
  console.error('[OIDC] Missing VITE_ZITADEL_* env vars');
}

export const userManager = new UserManager({
  authority: issuer,
  client_id: clientId,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: postLogoutUri,
  response_type: 'code',
  scope: [
    'openid',
    'profile',
    'email',
    'offline_access',
    platformOrgId ? `urn:zitadel:iam:org:id:${platformOrgId}` : '',
  ]
    .filter(Boolean)
    .join(' '),
  automaticSilentRenew: true,
  loadUserInfo: true,

  // Tokens live only in memory — gone on tab close, unreadable via XSS
  // persisted stores. Silent renew restores the session from Zitadel's
  // auth-domain cookie on reload.
  userStore: new WebStorageStateStore({ store: new InMemoryWebStorage() }),

  // CSRF state/nonce must survive the redirect roundtrip but is single-use
  // and short-lived — sessionStorage is the right scope.
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
});

export const oidcProviderProps = {
  userManager,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
